import { BigNumber } from 'bignumber.js'
import web3NoAccount from 'utils/web3'

import { useState, useEffect } from 'react'

const GAS_MULTIPLIER = 1.5

/**
 * Gas price override for transactions. It stays undefined unless gas boost is on, so the
 * wallet prices each transaction itself when it is sent (web3 only fills in a gas price
 * when none is passed). A fixed price read once at page load goes stale, and a failed
 * read used to leave it at 0, which the RPC rejects as underpriced.
 */
const useGasBoost = () => {
  const [gasBoostedPrice, setGasBoostedPrice] = useState<number | undefined>(undefined)
  const isGasBoostEnabled = window?.localStorage?.getItem('isGasBoostEnabled') === 'true'

  useEffect(() => {
    if (!isGasBoostEnabled) {
      setGasBoostedPrice(undefined)
      return
    }
    const fetchWeb3GasPrice = async () => {
      try {
        const web3GasPrice = await web3NoAccount.eth.getGasPrice()
        const boosted = new BigNumber(web3GasPrice).multipliedBy(GAS_MULTIPLIER).integerValue(BigNumber.ROUND_CEIL)
        setGasBoostedPrice(boosted.gt(0) ? boosted.toNumber() : undefined)
      } catch (error) {
        setGasBoostedPrice(undefined)
      }
    }
    fetchWeb3GasPrice()
  }, [isGasBoostEnabled])

  return { gasBoostedPrice }
}
export default useGasBoost
